import { Dropdown } from 'primeng/dropdown';

/**
 * A pick in one of the Suburbs tool column's dropdowns (active region, Assign's sub-region, Sub-region mode's), #260.
 *
 * A mouse or touch pick closes the list at once: those handlers can run outside Angular's zone in this popup, so the
 * list otherwise stayed open and stale. PrimeNG 12 passes that click as the change's originalEvent. A keyboard step
 * (arrow keys, type-ahead) also selects, and so also emits onChange, but with no originalEvent; the list must stay
 * open to move through it (Enter, Escape and Tab close it as PrimeNG always has).
 */
export function pickClosesList(change: { originalEvent?: unknown } | null | undefined): boolean {
  return !!change?.originalEvent;
}

/** Close the dropdown's list after a pointer pick (see pickClosesList); leave it open after a keyboard step. */
export function closeAfterPick(
  dropdown: Pick<Dropdown, 'hide'>,
  change: { originalEvent?: unknown } | null | undefined
): void {
  if (pickClosesList(change)) dropdown.hide();
}
